import { render, staticRenderFns } from "./BackofficeRaci.vue?vue&type=template&id=5f6c756a&scoped=true"
import script from "./BackofficeRaci.vue?vue&type=script&lang=js"
export * from "./BackofficeRaci.vue?vue&type=script&lang=js"
import style0 from "./BackofficeRaci.vue?vue&type=style&index=0&id=5f6c756a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c756a",
  null
  
)

export default component.exports